export default __webpack_public_path__ + "static/media/risk-roulette-small.761605cd.jpg";